// React-related
import React from 'react';
import { Link, Route, Routes, useLocation } from 'react-router-dom';

// Internal
import Transactions from '../pages/transactions';
import Settings from '../pages/settings/settings';
import Accounts from '../pages/accounts/accounts';
// import Accounting from '../pages/accounting';
import AddAccount from '../pages/accounts/add';
import { Column, Columns } from '../components/Grid';
import NotFound404 from '../pages/notFound404';
import ContactUs from '../pages/contact-us';

// Hooks
import useOrg from '../hooks/useOrg';

// Firebase
import { auth } from '../services/firebase';
import { useAuthState } from 'react-firebase-hooks/auth';

// Antd
import { Affix, Avatar, Button, Divider, Drawer, Dropdown, Menu, Space } from 'antd';

// Icons
import {
  DollarSign,
  List,
  LogOut,
  Menu as MenuIcon,
  Settings as SettingsIcon,
} from 'react-feather';

// Misc
import LOGO from '../img/logo.svg';
import { truncate } from 'lodash-es';

// Styles
import styles from './Dashboard.module.scss';
import Typography from './Typography';

interface SidebarProps {
  isMobile?: boolean;
}
function Sidebar({ isMobile }: SidebarProps) {
  const location = useLocation();

  return (
    <Affix offsetTop={0.000001}>
      <div className={isMobile ? styles['app__sidebar-mobile'] : styles['app__sidebar-desktop']}>
        <div className={styles.app__sidebar__container}>
          <div>
            <div className={styles.app__sidebar__container__logo}>
              <Link to="/">
                <img src={LOGO} />
              </Link>
            </div>

            <Menu selectedKeys={[location.pathname]} mode="inline">
              <Menu.Item key="/accounts">
                <Link to="/accounts">
                  <DollarSign /> Accounts
                </Link>
              </Menu.Item>

              {/* 
              <Menu.Item key="/accounts/add">
                <Link to="/accounts/add">
                  <PlusCircle /> Add account
                </Link>
              </Menu.Item> */}
              {/* 
              <Menu.Item key="/accounting">
                <Link to="/accounting">
                  <BookOpen /> Accounting
                </Link>
              </Menu.Item> */}

              <Menu.Item key="/">
                <Link to="/">
                  <List /> Transactions
                </Link>
              </Menu.Item>
            </Menu>
          </div>

          <div className={styles.app__sidebar__container__spacer}></div>

          <div>
            <Menu
              selectedKeys={[location.pathname === '/settings' ? 'settings' : '']}
              mode="inline"
            >
              <Menu.Item key="settings">
                <Link to="/settings">
                  <SettingsIcon /> Settings
                </Link>
              </Menu.Item>
            </Menu>

            <Divider />

            <Header />
          </div>
        </div>
      </div>
    </Affix>
  );
}

function Header() {
  const [user] = useAuthState(auth);
  const org = useOrg();

  console.log('user', user, org);

  const nameToDisplay = user?.email || user?.displayName || '';
  return (
    <Dropdown
      overlay={
        <Menu>
          <Menu.Item key="signout">
            <Button type="link" onClick={() => auth.signOut()}>
              <LogOut /> Sign Out
            </Button>
          </Menu.Item>
        </Menu>
      }
      trigger={['click']}
      placement="topRight"
    >
      <a className="ant-dropdown-link" href="#todo">
        <Space>
          <Avatar style={{ backgroundColor: '#f56a00' }}>{nameToDisplay[0]}</Avatar>
          <div>
            <Typography type="text_xs">{truncate(nameToDisplay, { length: 22 })}</Typography>
            <Typography type="text_xs" color="secondary">
              {org.name}
            </Typography>
          </div>
        </Space>
      </a>
    </Dropdown>
  );
}

export default function Dashboard() {
  const location = useLocation();

  const [drawerVisible, setDrawerVisible] = React.useState(false);
  const showDrawer = () => {
    setDrawerVisible(true);
  };

  const onDrawerClose = () => {
    setDrawerVisible(false);
  };

  React.useEffect(() => {
    setDrawerVisible(false);
  }, [location.pathname]);

  if (location.pathname === '/accounts/add') {
    return <AddAccount />;
  }

  return (
    <>
      <Drawer
        placement="left"
        closable={false}
        onClose={onDrawerClose}
        visible={drawerVisible}
        className="no-padding sidebar"
      >
        <Sidebar isMobile={true} />
      </Drawer>

      <button className={styles['app__sidebar-trigger']} onClick={showDrawer}>
        <MenuIcon />
      </button>

      <Columns className={styles.app}>
        <Column className={styles.app__sidebar}>
          <Sidebar />
        </Column>

        <Column className={styles.app__content}>
          <div className={styles.app__content__container}>
            <Routes>
              <Route path="/" element={<Transactions />} />
              <Route path="/contact-us" element={<ContactUs />} />
              <Route path="/accounts" element={<Accounts />} />
              {/* <Route path="/accounting" element={<Accounting />} /> */}
              <Route path="/settings" element={<Settings />} />
              <Route path="/*" element={<NotFound404 />} />
            </Routes>
          </div>
        </Column>
      </Columns>
    </>
  );
}
